import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { PaymentMethodResponse } from '@klab-berlin/api-sdk/lib/types/responses/Billing';

import { paymentMethodMap } from '../../utils/paymentMethodMapUserPaymentMethod';
import { UserPaymentMethodType } from '../../types/User';
import { spaces } from '../../assets/styles/themes/tokens';
import SettingItem from '../SettingItem';
import useScreenSize from '../../utils/useScreenSize';
import PaymentMethods from './PaymentMethods';

interface PaymentInfoRendererProps {
  isEditMode: boolean;
  currentPaymentMethod: PaymentMethodResponse;
  children: React.ReactNode;
}

const PaymentInfoRenderer = ({
  isEditMode,
  currentPaymentMethod,
  children
}: PaymentInfoRendererProps) => {
  const { isXsScreen, isSmScreen } = useScreenSize();
  const { t } = useTranslation();

  const [selectedMethod, setSelectedMethod] = useState<string>(currentPaymentMethod.type);

  // If the current payment method is invoice, only at that case invoice will available
  const availablePaymentMethods: UserPaymentMethodType[] = [
    ...(currentPaymentMethod.type === UserPaymentMethodType.INVOICE
      ? [UserPaymentMethodType.INVOICE]
      : []),
    UserPaymentMethodType.SEPA,
    UserPaymentMethodType.PAYPAL,
    UserPaymentMethodType.CREDIT_CARD
  ];

  const onChangeMethod = (method: UserPaymentMethodType) => setSelectedMethod(method);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: (isXsScreen || isSmScreen) ? '1fr' : '1fr 1fr',
        gap: spaces.md,
      }}
    >
      <SettingItem title={t('Payment method')} sx={{ display: 'inline-flex' }}>
        <PaymentMethods
          isEditMode={isEditMode}
          availablePaymentMethods={availablePaymentMethods}
          selectedMethodType={selectedMethod}
          currentMethodIcon={paymentMethodMap(currentPaymentMethod).icon}
          currentMethodText={paymentMethodMap(currentPaymentMethod).text}
          onChangeMethod={onChangeMethod}
        />
      </SettingItem>
      <SettingItem title={t('Payment rhythm')}>
        {children}
      </SettingItem>
    </Box>
  );
};

export default PaymentInfoRenderer;
